import { createAsyncThunk } from "@reduxjs/toolkit";
import classesService from "../../../api/services/classes";

export const fetchClasses = createAsyncThunk(
  "classes/fetchClasses",
  async (requestData) => {
    return await classesService.fetchClasses();
  }
);

export const createClass = createAsyncThunk(
  "classes/createClass",
  async (requestData) => {
    return await classesService.createClass(requestData);
  }
);

export const editClass = createAsyncThunk(
  "classes/editClass",
  async (requestData) => {
    return await classesService.editClass(requestData);
  }
);

export const deleteClass = createAsyncThunk(
  "classes/deleteClass",
  async (requestData) => {
    return await classesService.deleteClass(requestData);
  }
);

export const fetchTeacherClasses = createAsyncThunk(
  "classes/fetchTeacherClasses",
  async (classId) => {
    return await classesService.fetchTeacherClasses(classId);
  }
);
